/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AssetIncomeMonthResponse } from './AssetIncomeMonthResponse';
import {
    AssetIncomeMonthResponseFromJSON,
    AssetIncomeMonthResponseFromJSONTyped,
    AssetIncomeMonthResponseToJSON,
    AssetIncomeMonthResponseToJSONTyped,
} from './AssetIncomeMonthResponse';
import type { SpecialPaymentCount } from './SpecialPaymentCount';
import {
    SpecialPaymentCountFromJSON,
    SpecialPaymentCountFromJSONTyped,
    SpecialPaymentCountToJSON,
    SpecialPaymentCountToJSONTyped,
} from './SpecialPaymentCount';

/**
 * 
 * @export
 * @interface AssetIncomeResponse
 */
export interface AssetIncomeResponse {
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    payerNameAndAddress: string | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    incomeType: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasSpecialPayments: boolean | null;
    /**
     * 
     * @type {SpecialPaymentCount}
     * @memberof AssetIncomeResponse
     */
    specialPaymentCount: SpecialPaymentCount | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    dailyRate: number | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    note: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    isPartiallyGarnished: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasEmployerFamilyAllowance: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasEmployerSettledExpenses: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasBenefitInKind: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    benefitInKindAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    receivesTips: boolean | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    monthlyTipAmount: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    hasExpenseAllowances: boolean | null;
    /**
     * 
     * @type {boolean}
     * @memberof AssetIncomeResponse
     */
    isAverageRepresentative: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof AssetIncomeResponse
     */
    nonRepresentativeReason: string | null;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    actualAverageIncome: number | null;
    /**
     * 
     * @type {Array<AssetIncomeMonthResponse>}
     * @memberof AssetIncomeResponse
     */
    months: Array<AssetIncomeMonthResponse>;
    /**
     * 
     * @type {number}
     * @memberof AssetIncomeResponse
     */
    averageIncome: number | null;
}



/**
 * Check if a given object implements the AssetIncomeResponse interface.
 */
export function instanceOfAssetIncomeResponse(value: object): value is AssetIncomeResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('payerNameAndAddress' in value) || value['payerNameAndAddress'] === undefined) return false;
    if (!('incomeType' in value) || value['incomeType'] === undefined) return false;
    if (!('hasSpecialPayments' in value) || value['hasSpecialPayments'] === undefined) return false;
    if (!('specialPaymentCount' in value) || value['specialPaymentCount'] === undefined) return false;
    if (!('dailyRate' in value) || value['dailyRate'] === undefined) return false;
    if (!('note' in value) || value['note'] === undefined) return false;
    if (!('isPartiallyGarnished' in value) || value['isPartiallyGarnished'] === undefined) return false;
    if (!('hasEmployerFamilyAllowance' in value) || value['hasEmployerFamilyAllowance'] === undefined) return false;
    if (!('hasEmployerSettledExpenses' in value) || value['hasEmployerSettledExpenses'] === undefined) return false;
    if (!('hasBenefitInKind' in value) || value['hasBenefitInKind'] === undefined) return false;
    if (!('benefitInKindAmount' in value) || value['benefitInKindAmount'] === undefined) return false;
    if (!('receivesTips' in value) || value['receivesTips'] === undefined) return false;
    if (!('monthlyTipAmount' in value) || value['monthlyTipAmount'] === undefined) return false;
    if (!('hasExpenseAllowances' in value) || value['hasExpenseAllowances'] === undefined) return false;
    if (!('isAverageRepresentative' in value) || value['isAverageRepresentative'] === undefined) return false;
    if (!('nonRepresentativeReason' in value) || value['nonRepresentativeReason'] === undefined) return false;
    if (!('actualAverageIncome' in value) || value['actualAverageIncome'] === undefined) return false;
    if (!('months' in value) || value['months'] === undefined) return false;
    if (!('averageIncome' in value) || value['averageIncome'] === undefined) return false;
    return true;
}

export function AssetIncomeResponseFromJSON(json: any): AssetIncomeResponse {
    return AssetIncomeResponseFromJSONTyped(json, false);
}

export function AssetIncomeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetIncomeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'payerNameAndAddress': json['payerNameAndAddress'],
        'incomeType': json['incomeType'],
        'hasSpecialPayments': json['hasSpecialPayments'],
        'specialPaymentCount': SpecialPaymentCountFromJSON(json['specialPaymentCount']),
        'dailyRate': json['dailyRate'],
        'note': json['note'],
        'isPartiallyGarnished': json['isPartiallyGarnished'],
        'hasEmployerFamilyAllowance': json['hasEmployerFamilyAllowance'],
        'hasEmployerSettledExpenses': json['hasEmployerSettledExpenses'],
        'hasBenefitInKind': json['hasBenefitInKind'],
        'benefitInKindAmount': json['benefitInKindAmount'],
        'receivesTips': json['receivesTips'],
        'monthlyTipAmount': json['monthlyTipAmount'],
        'hasExpenseAllowances': json['hasExpenseAllowances'],
        'isAverageRepresentative': json['isAverageRepresentative'],
        'nonRepresentativeReason': json['nonRepresentativeReason'],
        'actualAverageIncome': json['actualAverageIncome'],
        'months': ((json['months'] as Array<any>).map(AssetIncomeMonthResponseFromJSON)),
        'averageIncome': json['averageIncome'],
    };
}

export function AssetIncomeResponseToJSON(json: any): AssetIncomeResponse {
    return AssetIncomeResponseToJSONTyped(json, false);
}

export function AssetIncomeResponseToJSONTyped(value?: AssetIncomeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'payerNameAndAddress': value['payerNameAndAddress'],
        'incomeType': value['incomeType'],
        'hasSpecialPayments': value['hasSpecialPayments'],
        'specialPaymentCount': SpecialPaymentCountToJSON(value['specialPaymentCount']),
        'dailyRate': value['dailyRate'],
        'note': value['note'],
        'isPartiallyGarnished': value['isPartiallyGarnished'],
        'hasEmployerFamilyAllowance': value['hasEmployerFamilyAllowance'],
        'hasEmployerSettledExpenses': value['hasEmployerSettledExpenses'],
        'hasBenefitInKind': value['hasBenefitInKind'],
        'benefitInKindAmount': value['benefitInKindAmount'],
        'receivesTips': value['receivesTips'],
        'monthlyTipAmount': value['monthlyTipAmount'],
        'hasExpenseAllowances': value['hasExpenseAllowances'],
        'isAverageRepresentative': value['isAverageRepresentative'],
        'nonRepresentativeReason': value['nonRepresentativeReason'],
        'actualAverageIncome': value['actualAverageIncome'],
        'months': ((value['months'] as Array<any>).map(AssetIncomeMonthResponseToJSON)),
        'averageIncome': value['averageIncome'],
    };
}

